import { useNonEntityMutation } from '@melio/api-client';
import { ApiKeys, PutOrganizationRequest, VexOrganizationsApiClient } from '@melio/platform-api-axios-client';

export const useUpdateVendorOrganization = (organizationId: string) =>
  useNonEntityMutation(
    (businessDetails: PutOrganizationRequest) =>
      VexOrganizationsApiClient.putOrganization(organizationId, businessDetails),
    [ApiKeys.VexOrganizationsApi, 'collection', organizationId, 'putOrganization']
  );
